import { observeElement } from '@uvocore-front/utils';
/* eslint-disable no-new */
import Carousel from '../CustomCarousel';
import './style.scss';

const imagesColumnsSelector = '.imageList-withSlider__content';
const imagesColumnsItems = document.querySelectorAll(imagesColumnsSelector);

if (imagesColumnsItems) {
  const initCarousel = (selector) => {
    new Carousel({
      selector,
      itemWidth: 200,
      margin: 40,
      isSetNavButtonsPosition: false,
      responsive: {
        1024: {
          inactive: true,
        },
      },
    });
  };

  observeElement({
    element: imagesColumnsSelector,
    callback: () => {
      [].slice.call(imagesColumnsItems).forEach((item) => initCarousel(item));
    },
  });
}
